import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./TestimonialSection.css";
import Badge from "../ServiceSection/Badge";



const reviews = [
  {
    name: "John Miller",
    service: "Residential Roof Repair Client",
    location: "Homeowner",
    text: "After a heavy storm, our roof started leaking badly. The team responded quickly and fixed everything within a day. Very professional and honest service. Highly recommended!",
  },
  {
    name: "Sarah Thompson",
    service: "Roof Replacement Customer",
    location: "Homeowner",
    text: "We needed a full roof replacement and the process was smooth from start to finish. Clear communication, fair pricing, and excellent workmanship. Our home looks amazing now.",
  },
  {
    name: "David Reynolds",
    service: "Commercial Roofing Client",
    location: "Property Manager",
    text: "We manage multiple commercial buildings, and they handled our roofing project efficiently with minimal disruption. Great team for large-scale roofing work.",
  },
  {
    name: "Emily Carter",
    service: "Emergency Roof Repair Client",
    location: "Homeowner",
    text: "They came out the same day we called for emergency repair. Fixed the issue fast and explained everything clearly. Very reliable roofing company.",
  },
  {
    name: "Michael Brown",
    service: "Commercial Roof Maintenance Client",
    location: "Facilities Manager",
    text: "We hired them for routine roof inspections and maintenance across several properties. Very detailed reports and proactive solutions. Excellent service.",
  },
  {
    name: "Amanda Wilson",
    service: "Roof Inspection Client",
    location: "Homeowner",
    text: "Booked a free inspection and they were very honest about what needed fixing. No pressure, just professional advice. That’s rare these days.",
  },
  {
    name: "Robert Johnson",
    service: "Industrial Roofing Project Client",
    location: "Property Manager",
    text: "They handled a large industrial roofing project for us. Strong project management, on-time delivery, and solid quality work. Very satisfied.",
  },
];

const stats = [
  { value: "4.9",  label: "Google Rating", icon: "bi-star-fill" },
  { value: "500+", label: "Projects Done",  icon: "bi-house-check-fill" },
  { value: "100%", label: "Satisfaction",   icon: "bi-shield-fill-check" },
  { value: "24h",  label: "Response Time",  icon: "bi-clock-fill" },
];

const TestimonialSection = () => {
  const allReviews = [...reviews, ...reviews];

  return (
    <section className="cs-section ts-section" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Decorative shapes */}
      <div className="ts-bg-shape ts-shape-1"></div>
      <div className="ts-bg-shape ts-shape-2"></div>

      <div className="container position-relative">

        {/* Header */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="cs-badge d-flex justify-content-center">
           <Badge className="d-flex justify-content-center text-center mx-auto" text={"Customer Feedback"}></Badge>
           </div>
            <h2 className="cs-title ts-main-heading">
              Trusted by Hundreds of <br />
              <span className="ts-red">Property Owners</span>
            </h2>
            <div className="ts-header-line"></div>
          </div>
        </div>

        {/* Infinite Slider */}
        <div className="cs-content ts-slider-wrapper">
          <div className="ts-slider-track">
            {allReviews.map((item, index) => (
              <div className="ts-review-card" key={index}>
                <div className="ts-card-top">
                  <div className="ts-quote-icon">
                    <i className="bi bi-quote"></i>
                  </div>
                  <div className="ts-stars">
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                  </div>
                </div>

                <p className="ts-review-body">"{item.text}"</p>

                <div className="ts-card-footer">
                  <div>
                    <h5 className="ts-user-name">{item.name}</h5>
                    <span className="ts-user-meta">{item.service}</span>
                    <span className="ts-user-location">{item.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Bar */}
        <div className="row g-0 ts-stats-row mt-5">
          {stats.map((stat, idx) => (
            <div className="col-6 col-md-3" key={idx}>
              <div className="ts-stat-box">
                <i className={`bi ${stat.icon} ts-stat-icon`}></i>
                <h3 className="ts-stat-num">{stat.value}</h3>
                <p className="ts-stat-text">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TestimonialSection;